import type { Category } from "@/types";

export const categories: Category[] = [
  {
    id: "drama",
    name: "影视剧",
    icon: "ri-film-line",
    description: "精选电影与热播电视剧，涵盖悬疑、都市、古装、科幻等多种题材，高清免费在线观看。",
    accent: "primary",
  },
  {
    id: "variety",
    name: "综艺",
    icon: "ri-mic-2-line",
    description: "搞笑、音乐、美食、竞技各类热门综艺应有尽有，每周持续更新最新内容。",
    accent: "secondary",
  },
  {
    id: "original",
    name: "原创",
    icon: "ri-video-line",
    description: "平台自制的原创短片与系列内容，主张贴近生活、温暖治愈的创作表达。",
    accent: "accent",
  },
  {
    id: "anime",
    name: "动漫",
    icon: "ri-emotion-happy-line",
    description: "覆盖国漫与日漫热门作品，科幻、热血、治愈、奇幻多元题材一网打尽。",
    accent: "primary",
  },
  {
    id: "documentary",
    name: "纪录片",
    icon: "ri-earth-line",
    description: "自然、人文、历史、科普优质纪录片，带你看见更广阔也更真实的世界。",
    accent: "accent",
  },
];